import {fetchJsonV1} from '@sinclair-digital/v2-content-service/lib/fetch';

export interface BrandType {
    uuid: string;
    callLetters: string;
}

interface DataWrapper {
    data: BrandType[];
    message: string;
    success: boolean;
    total: number | null;
}
/**
 *  fetches a list of all brands in the system
 */
export const fetchBrandList = (): Promise<DataWrapper> => fetchJsonV1('/api/rest/facade/brands');

const appContext = () => globalThis.__sbgModules?._appContext;
const getAvailableTargets = () => appContext()?.userModel?.get('availableTargets').toJSON() || [];

/**
 * get all brand uuids the user has permission for
 */
export const getAvailableBrandUuids = (): string[] =>
    getAvailableTargets().map(({site}) => site.brandUuid) || [];

const getBrandUuidUsingPropertyUuid = (propertyUuid: string): string[] =>
    getAvailableTargets().find(({site}) => site.uuid === propertyUuid).site.brandUuid;

/**
 * get all brand uuids the user has admin permission for
 */
export const getAvailableAdminBrandUuids = (): string[] => {
    const isGlobalAdmin = appContext().isAdmin();
    const isGlobalProducer = appContext().userModel.get('roles')['com.sinclair.digital.producer']?.global; // Regional Producers
    if (isGlobalAdmin || isGlobalProducer)  return getAvailableBrandUuids();

    const propertyUuidsWithAdminRoles = appContext().userModel.get('roles')['com.sinclair.digital.facade.site.admin']?.propertyUuids || [];
    return propertyUuidsWithAdminRoles.map(getBrandUuidUsingPropertyUuid);
};
